import { type TagProps } from '3-components/Tag/Tag';
import { type CategoryModel } from 'cms/cms-types';

export const resolveCategoriesToBadges = (data: (CategoryModel | null)[] | null | undefined): TagProps[] | undefined => {
    if (!data) {
        return undefined;
    }

    return data.map(item => {
        // the autogenerated produce | null for each item, need to remove the | null type
        const { Description } = item as NonNullable<typeof item>;

        return { label: Description || '', skin: 'brand-1' };
    });
};
